import type { NotificationBroadcastInterventionAssignPayload } from "../notification-broadcast.type";

import { NOTIFICATION_BROADCAST_TYPE } from "../notification-broadcast.enum";
import {
  isNotificationBroadcastNamedModel,
  isValidNotificationBroadcastBase,
} from "../notification-broadcast.helper";

export const isNotificationBroadcastInterventionAssignPayload = (
  payload: unknown
): payload is NotificationBroadcastInterventionAssignPayload =>
  isValidNotificationBroadcastBase(payload) &&
  payload.event_type === NOTIFICATION_BROADCAST_TYPE.INTERVENTION_ASSIGN &&
  "interventions" in payload &&
  Array.isArray(payload.interventions) &&
  payload.interventions.length > 0 &&
  payload.interventions.every(isNotificationBroadcastNamedModel) &&
  "user" in payload &&
  isNotificationBroadcastNamedModel(payload.user);
